<template>
  <div>
    <v-container class="global-margin">
      <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <h2 class="display-1 w-100 pb-5">Pretraga</h2>
          <v-card flat class="px-3">
            <v-row>
              <v-col cols="12" sm="8">
                <v-text-field
                  outlined
                  :value="$route.query.search"
                  hide-details
                  label="Upiši pojam"
                  append-icon="search"
                  @keyup.enter.native="getSearch"
                  v-model="search"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" style="min-height: 60px">
                <v-btn
                  rounded
                  depressed
                  color="#084776"
                  dark
                  class="text-capitalize"
                  height="100%"
                  width="100%"
                  @click="getSearch()"
                >Pretraži</v-btn>
              </v-col>
              <v-col cols="12" class="text-center">
                <p class="title" style="color: #084776;">Rezultati pretrage</p>
                <div
                  style="height: 1px; background: linear-gradient(90deg, rgb(255, 255, 255), rgb(8, 71, 118), rgb(255, 255, 255));"
                ></div>
              </v-col>
              <v-col cols="12" class="text-center">
                <v-progress-circular v-if="loading" :size="60" color="#084776" indeterminate></v-progress-circular>
              </v-col>
              <div v-if="items.length" style="width: 100%">
                <v-col cols="12" md="12" class="pt-0" v-for="(item, i) in items" :key="i">
                  <v-row align="center">
                    <v-col cols="12" sm="9">
                      <span class="title" style="color: #084776;">{{item.title}}</span>
                      <p class="subtitle grey--text mb-0">
                        <b>
                          {{item.course.title}} -
                          <template v-if="i.grade == 10">
                            Ostalo
                          </template>
                          <template v-else>
                            {{item.school_class.grade}}. razred {{item.school_class.high_school == 0 ? 'OŠ' : 'SŠ'}}
                          </template>
                        </b>
                      </p>
                      <p class="subtitle grey--text mb-0">{{item.author}}</p>
                      <p class="body mt-0" v-if="item.parent">{{item.parent.title}}</p>
                      <p></p>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-btn
                        outlined
                        rounded
                        color="#084776"
                        class="text-capitalize"
                        :to="'/lekcije/' + item.id"
                      >Prikaži lekciju</v-btn>
                    </v-col>
                  </v-row>
                  <v-divider v-if="i < items.length-1"></v-divider>
                </v-col>
              </div>
              <v-col cols="12" class="text-center" v-else>
                  <p v-if="loading" class="mt-0"></p>
                  <h4 v-else class="subtitle pa-4 error--text text-center">Za traženi pojam nema rezultat pretrage!</h4>
              </v-col>
              
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      search: "",
      search1: "",
      loading: false,
      breadcrumbs: [
        {
          text: "Naslovnica",
          disabled: false,
          to: "/"
        },
        {
          text: "Pretraga",
          disabled: true
        }
      ]
    };
  },

  mounted() {
    this.search = this.$route.query.search;
    this.getSearch();
  },

  methods: {
    getSearch() {
    this.loading = true;
      skoleApi.get("/lekcije?search=" + this.search).then(response => {
        if (response.status === 200) {
          this.items = response.data;
        }
      }).finally(() => {
          this.loading = false;
      });
    }
  }
};
</script>